import * as React from "react";
import {useState} from "react";
import {SelectField, Button} from "web-com";
import {imageBaseUrl} from "config";
import "IncompleteInfoV2/BankStatementV2/BankSelection/SelectDropdown/style.scss";
import {IBankDetails} from "IncompleteInfoV2/BankStatementV2";

export interface IBankOptions {
    name: string;
    value: string | number;
    isNetBanking: boolean;
    isDisabled?: boolean;
}

interface IProps {
    options: IBankOptions[];
    disabled: boolean;
    onBankSelect: (id: string, name: string, isNetBanking: boolean) => void;
    bankDetails?: IBankDetails;
}

const majorBankList = [
    {
        image: "axis-bank-logo.png",
        id: "2",
    },
    {
        image: "hdfc-bank-logo.png",
        id: "20",
    },
    {
        image: "icici-bank-logo.png",
        id: "22",
    },
    {
        image: "statebank-logo.png",
        id: "35",
    },
];

const SelectBank = (props: IProps) => {
    const [selectedBank, setSelectedBank] = useState({id: props.bankDetails?.id || null, index: null});
    const [error, setError] = useState<string>(null);
    const onChangeHandler = (fieldName: string, value: string | number) => {
        setSelectedBank({id: value.toString(), index: null});
        setError(null);
    };
    const buttonOnClick = () => {
        if (selectedBank.id) {
            let selectedBankName: string;
            let isNetBanking: boolean;
            props.options.forEach((option) => {
                if (option.value === selectedBank.id) {
                    selectedBankName = option.name;
                    isNetBanking = option.isNetBanking;
                }
            });
            props.onBankSelect(selectedBank.id, selectedBankName, isNetBanking);
        } else {
            setError("Please select bank.");
        }
    };

    const selectMajorBank = (id: string, index: number) => {
        setSelectedBank({id, index});
        setError(null);
    };

    return(
        <div className="select-bank-container">
            <h6>{selectedBank.id ? "Selected Bank" : "Please select bank"}</h6>
            {
                (!props.disabled) &&
                <div className="major-bank-container">
                {
                    majorBankList.map((banks, index) => {
                        return(
                            <div
                              key={index}
                              className={`bank-name ${selectedBank.index === index ? "selected" : ""}`}
                              onClick={() => selectMajorBank(banks.id, index)}>
                                <img
                                  src={`${imageBaseUrl}/img/logo/${banks.image}`}
                                  alt="Bank-Name"
                                />
                            </div>
                        );
                    })
                }
             </div>
            }
            <SelectField
              options={props.options}
              errorMsg={error}
              onChangeHandler={onChangeHandler}
              fieldName={"selectBank"}
              value={selectedBank.id ? selectedBank.id : ""}
              disabled={props.disabled}
            />
            {!props.disabled && <Button buttonText="Continue" onClick={buttonOnClick} rounded={true}/>}
        </div>
    );
};

export default SelectBank;
